
import { Vue } from "vue-class-component";

export default class PlusSquare extends Vue {}
